import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import clx from 'classnames';

import Typography from '../../../_ui/_blocks/Typography/Typography';
import Button from '../../../_ui/_blocks/Buttons/Button/Button';
import Icon from '../../../_ui/_blocks/Icon/Icon';

import styles from './SortAndFilterDialog.module.css';

interface Props {
    children: React.ReactNode;
    isOpen?: boolean;
    onClose: () => void;
    title: string;
    size?: 'content' | 'window';
}

const SortAndFilterDialog = ({ children, isOpen, onClose, title, size = 'content' }: Props) => {
    const panelClassNames = clx(styles.panel, {
        [styles.panelWindowHeight]: size === 'window',
    });

    return (
        <Transition show={isOpen}>
            <Dialog onClose={onClose} className={styles.dialog} data-testid="sort-and-filter-dialog">
                <Transition.Child
                    enter="transition-opacity ease-in-out duration-medium"
                    enterFrom="opacity-0"
                    enterTo="opacity-1"
                    leave="transition-opacity ease-in-out duration-slow"
                    leaveFrom="opacity"
                    leaveTo="opacity-0"
                >
                    <div className="absolute top-0 left-0 w-screen h-screen opacity-90 pointer-events-none transition-all bg-content-foundation" />
                </Transition.Child>
                <Transition.Child
                    enter="transition ease-in-out duration-fast transform"
                    enterFrom="translate-y-full"
                    enterTo="translate-y-0"
                    leave="transition ease-in-out duration-fast transform"
                    leaveFrom="translate-y-0"
                    leaveTo="translate-y-050"
                    as={Fragment}
                >
                    <Dialog.Panel className={panelClassNames}>
                        <div className={styles.header}>
                            <Dialog.Title>
                                <Typography typeset="heading" size="200" lineHeight="500">
                                    {title}
                                </Typography>
                            </Dialog.Title>
                            <Button
                                variant="none"
                                size="none"
                                onClick={onClose}
                                title={`Close ${title}`}
                                className={styles.closeButton}
                                data-testid="sort-and-filter-dialog-close-button"
                            >
                                <Icon icon="cross-light" alt="cross Icon" size="small" />
                            </Button>
                        </div>
                        {children}
                    </Dialog.Panel>
                </Transition.Child>
            </Dialog>
        </Transition>
    );
};

export default SortAndFilterDialog;
